import { FC, ReactElement } from 'react';
import { Filter, ResourceComponentProps, TextInput } from 'react-admin';
import { ResourceName } from 'types/resources';

export const ChatsFilters: FC<ResourceComponentProps> = (props): ReactElement => (
  <Filter {...props}>
    <TextInput key="name" source={`${ResourceName.CHATS}.filter`} label="Search chats by name" alwaysOn />
  </Filter>
);
